import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';
import { Icon } from '../Icon/Icon';
import './Message.css';

interface Props extends GlobalProps {
  type?: 'success' | 'warning' | 'error';
  title?: string;
  footer?: React.ReactNode;
  open?: boolean;
  onClose?: () => void;
}

export function Message({ type = 'warning', title, onClose, children, footer }: Props): JSX.Element {
  return (
    <div className={classnames('message', `message--${type}`)}>
      {(title || onClose) && (
        <header className="message__header">
          {title && <p className="message__title">{title}</p>}
          {onClose && <Icon name="remove" className="message__close" onClick={onClose} />}
        </header>
      )}
      <div className="message__body">{children}</div>
      {footer && <footer className="message__footer">{footer}</footer>}
    </div>
  );
}
